import clsx from 'clsx'

import ArrowRightIcon from 'shared/icons/arror_right_icon.svg'

import styles from './styles.module.scss'

export enum TYPE_HEIGHT_ITEM {
  REGULAR = 'regularHeight',
  HIGHER = 'higherHeight',
}

interface Props {
  icon?: string
  title?: string
  subTitle?: string
  right?: string
  height?: TYPE_HEIGHT_ITEM
  onClick?: () => void
}

export const ItemArrow = ({
  icon,
  title,
  right,
  subTitle,
  height = TYPE_HEIGHT_ITEM.REGULAR,
  onClick,
}: Props) => {
  return (
    <div
      onClick={onClick}
      className={clsx(styles.container, styles[height])}
    >
      <div className={styles.left}>
        {icon ? (
          <div className={styles.wrapperIcon}>
            <img
              src={icon}
              alt=""
            />
          </div>
        ) : null}

        <div
          className={clsx(
            height === TYPE_HEIGHT_ITEM.REGULAR
              ? styles.textWrapper
              : styles.textWrapperHigher,
          )}
        >
          <p className={styles.title}>{title}</p>
          <p className={styles.subTitle}>{subTitle}</p>
        </div>
      </div>

      <div className={styles.right}>
        {right ? <span className={styles.text}>{right}</span> : null}

        <div className={styles.wrapperArrow}>
          <img
            src={ArrowRightIcon}
            alt=""
          />
        </div>
      </div>
    </div>
  )
}
